var React = require('react');

function SectionButtonIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1E1E1E","fillRule":"evenodd","d":"M6.597 5.403V.597C6.597.267 6.33 0 6 0c-.33 0-.597.267-.597.597v4.806H.597C.267 5.403 0 5.67 0 6c0 .33.267.597.597.597h4.806v4.806c0 .33.267.597.597.597.33 0 .597-.267.597-.597V6.597h4.806c.33 0 .597-.267.597-.597 0-.33-.267-.597-.597-.597H6.597z"}));
}

SectionButtonIcon.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = SectionButtonIcon;

SectionButtonIcon.default = SectionButtonIcon;
